
<template>
<div>
<b-container class="content bg-primary" fluid="true" >
        <b-row align-h="center" class="bg-primary p-0">
          <div
            class="col-12 text-center mt-4 p-5"
            style="min-width: 250px">
              <b-img :src="logoPath" fluid alt="gender app logo" width="500"></b-img>
          </div>
          <div
            class="col-12 text-center p-5"
            style="min-width: 250px">
              <b-img :src="maintenaceWindowImage" fluid alt="Gendi" width="100"></b-img>
          </div>
          <div
            class="col-12 text-center text-white mt-0 p-3"
            style="min-width: 250px">
          {{ $t('Thanks for logging in') }}
          </div>
          <div
            class="col-12 text-center text-white p-3"
            style="min-width: 250px">
          {{ $t('You can close this window and start the add-in in your Word-Client') }}
          </div>
          <div
            class="col-12 text-center text-white p-3"
            style="min-width: 250px">
          </div>
        </b-row>
      </b-container>
  <GenderAppFooter/>
</div>
</template>

<script>
import { AuthService } from '@/services/auth.service'
import GenderAppFooter from '@/components/Footer'
import { COOKIE_DOMAIN } from '@/env'

var Vue = require('vue')

export default {
  name: 'magicLink',
  components: { GenderAppFooter },
  data () {
    return {
      logoPath: '/img/logo-7kx1k.png',
      maintenaceWindowImage: '/img/maintenance-gendi.png',
      username: '',
      token: ''
    }
  },
  mounted () {
    this.username = this.$route.params.username
    this.token = this.$route.params.token
    AuthService.setUsername(this.$route.params.username)
    AuthService.setAuthToken(this.$route.params.token)
    Vue.default.cookie.set('asdf', 'asdf', { expires: 9999 }, '/', COOKIE_DOMAIN)
  }
}

</script>

<style scoped>
</style>
